import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';
import WeekDaysSelector from 'components/form/RecurringForm/components/WeekDaysSelector/container';

export default styled(WeekDaysSelector)`
  .days-container {
    border: 1px solid red;
    widt: 100%;
    background-color: var(--grey200);
    border: 1px solid #d5dee3;
    border-radius: 4px;
    margin-bottom: ${gridSizes('L')};
  }
  .days-center {
    padding: ${gridSizes('M')} 8px;
    position: relative;

    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    label {
      text-transform: capitalize;
      margin-bottom: 0;
    }

    ${media.lessThan('small')`
    padding: ${gridSizes('M')};
    label{
        margin-bottom: ${gridSizes('M')};
    }
  `}

    &.error {
      border: 1px solid red;
    }
  }
`;
